export const DRAW = 5;
// Unclassified (legacy local) measures rank after levels 1-3 and administrative ones, before pure PPE.
const RANK = { 1: 1, 2: 2, 3: 3, 4: 4, 5: 6 };
const rank = (m) => RANK[m.control_level] ?? 5;

// Deterministic per Take 5: a new Take 5 gives a new draw, reloading the same one keeps it.
export const seeded = (str) => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i += 1) h = Math.imul(h ^ str.charCodeAt(i), 16777619);
  return () => { h = Math.imul(h ^ (h >>> 15), 2246822507); h = Math.imul(h ^ (h >>> 13), 3266489909); h ^= h >>> 16; return (h >>> 0) / 4294967296; };
};

const shuffle = (list, rnd) => {
  const pool = [...list];
  for (let i = pool.length - 1; i > 0; i -= 1) { const j = Math.floor(rnd() * (i + 1)); [pool[i], pool[j]] = [pool[j], pool[i]]; }
  return pool;
};

// Up to 5 proposals: one per control level in order of effectiveness (round-robin), random within a level, final order mixed.
export const drawMeasures = (all, seed) => {
  const rnd = seeded(seed);
  const sorted = [...all].sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
  if (sorted.length <= DRAW) return shuffle(sorted, rnd);
  const groups = {};
  sorted.forEach((m) => { (groups[rank(m)] ||= []).push(m); });
  const queues = Object.keys(groups).map(Number).sort((a, b) => a - b).map((k) => shuffle(groups[k], rnd));
  const picked = [];
  while (picked.length < DRAW) {
    queues.forEach((q) => { if (q.length && picked.length < DRAW) picked.push(q.shift()); });
  }
  return shuffle(picked, rnd);
};
